import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import "./headband.scss"
import crumbContext from "contexts/crumbs"
import headbandContext from "contexts/headband"
export default function Headband(props) {
	const {icon, name, color, fonction, accueil, url, title, } = props
	const {crumbs, setCrumbs} = useContext(crumbContext)
    const {setHeadband} = useContext(headbandContext)
	const addCrumb = {
        title : title,
        icon : icon,
        page : url,
        color : color
    }

	return (
		<Link 
			to={url} 
			className='headband flex between'
			onClick={() => {
				setCrumbs(oldCrumbs => [...oldCrumbs, addCrumb])
				setHeadband({
					title : title,
					icon : icon,
					color : color
				})
				
			}} 
		>
			<div className="headbandIcon bckDarkBlue flex center">
				<img src={"/" +icon} alt={icon} />
				<img src="/finger-white.svg" className='finger' alt="" />
			</div>
			<div className={`title flex column center h100 ${color}`}>
				<p className='name'>{name}</p>
				<p className="fonction">{fonction}</p>
				{
					accueil.map((e, i) => (
						<div key={i} className="flex">
							<p className="name">{e.name}</p>
							&nbsp; • &nbsp;
							<p className="phone">{e.phone}</p>
						</div>
					))
				}
			</div>
		</Link>
	)
}
